import "./profile.css"
import Slider from "react-slick";
import check from "../../pages/task/check.svg";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import arrow from "../../pages/task/arrow.png";
import protect from "../../pages/task/shield.png";
import shield from "../../pages/task/heal.png";
import React from "react";
import {usePumpStore} from "../../store/pumpStore";
import {levels} from "../../helpers/levelHelpers";
import axios from "axios";
import coin from "../../assets/coin.svg";
import {Locales} from "../../helpers/localeHelpers";
import LanguagePicker from "../language/language";
import parse from 'html-react-parser'

const Artifacts = {
    skip: {
        level: 2,
        price: 100
    },
    shield: {
        level: 3,
        price: 500
    },
    heal: {
        level: 5,
        price: 1000
    }
}

export const Profile = () => {
    const {tasksCount, appInitData, difficulty, setDifficulty, artifacts, level, screenLayout, setScreenLayout, showArtDialog, setShowArtDialog, balance, setArtifacts, setBalance, language, setLanguage} = usePumpStore()


    const sliderSettings = {
        dots: false,
        infinite: false,
        arrows: false,
        autoplay: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        initialSlide: level - 1
    };

    const changeDifficulty = (diff) => {
        axios.post('https://pump.stt.market/api/change_user', {'chat_id': appInitData.user.id, 'difficulty': diff, 'language': language}).then()
    }

    const buyArtifact = (artifact) => {
        if (balance >= Artifacts[artifact].price && level >= Artifacts[artifact].level) {
            const newBalance = balance - Artifacts[artifact].price;
            setBalance(newBalance)
            axios.post('https://pump.stt.market/api/buy_artifact', {'chat_id': appInitData.user.id, 'artifact': artifact}).then(() => {
                artifacts.push(artifact)
                setArtifacts(artifacts)
                setShowArtDialog('')
            })
        }
    }

    const saveLanguage = (newLang) => {
        setLanguage(newLang)
        axios.post('https://pump.stt.market/api/change_user', {'chat_id': appInitData.user.id, 'difficulty': difficulty, 'language': newLang}).then()
    }

    return (
        <div className={"profile_wrapper"} style={{position: "relative"}}>
            <Slider {...sliderSettings}>
                {Object.keys(levels).map((item, key) => (
                    <div className={"level-item"} key={key}>
                        <div className={"multiplicator"}>x{levels[item].multiplicator}</div>
                        {tasksCount >= levels[item].count
                            ? <img src={levels[item].active} alt={''} />
                            : <img src={levels[item].inactive} alt={''} style={{opacity: '.3'}} />
                        }
                        <h4>{levels[item].name}</h4>
                        <p><span>{tasksCount >= levels[item].count && <img className="vector" alt="Vector" src={check} />} {levels[item].count}</span></p>
                    </div>
                ))}
            </Slider>
            {screenLayout === 'profile' && (
                <div style={{ position: "absolute", top: 10, left: 20 }}>
                    <LanguagePicker
                        current={language}
                        available={["EN", "RU"]}
                        direction={"down"}
                        onSave={saveLanguage}
                    />
                </div>
            )}
            <h4 className={"block-title"}>{parse(Locales[language].difficulty)}</h4>
            <div className={"difficulties"}>
                <ToggleButtonGroup
                    value={difficulty.toString()}
                    exclusive
                    onChange={(event, newDifficulty) => {if (newDifficulty) {setDifficulty(parseInt(newDifficulty)); changeDifficulty(parseInt(newDifficulty))}}}
                    aria-label="difficulty of tasks"
                    className={"difficulty-btns"}
                >
                    <ToggleButton value="1" aria-label="easy">
                        Easy
                    </ToggleButton>
                    <ToggleButton value="2" aria-label="medium">
                        Medium
                    </ToggleButton>
                    <ToggleButton value="3" aria-label="hard">
                        Hard
                    </ToggleButton>
                </ToggleButtonGroup>
            </div>
            <h4 className={"block-title"}>{parse(Locales[language].artifacts)}</h4>
            <div className={"artifacts"}>
                <div className={`art-item ${artifacts.includes('skip') && '_bought'}`} onClick={() => {
                    setShowArtDialog('skip');
                    setScreenLayout('artifacts')
                }}>
                    <img src={arrow} alt={'buy skip'} style={{ '-webkit-filter': 'drop-shadow(2px 2px 2px #222)',
                        filter: 'drop-shadow(2px 2px 2px #222)'}} />
                    <p>Rewind</p>
                </div>
                <div className={`art-item ${artifacts.includes('shield') && '_bought'}`} onClick={() => {
                    setShowArtDialog('shield');
                    setScreenLayout('artifacts')
                }}>
                    <img src={protect} alt={'buy skip'} style={{ '-webkit-filter': 'drop-shadow(3px 3px 3px #222)',
                        filter: 'drop-shadow(3px 3px 3px #222)'}} />
                    <p style={{marginTop: 5}}>Shield</p>
                </div>
                <div className={`art-item ${artifacts.includes('heal') && '_bought'}`} onClick={() => {
                    setShowArtDialog('heal');
                    setScreenLayout('artifacts')
                }}>
                    <img src={shield} alt={'buy skip'} style={{ '-webkit-filter': 'drop-shadow(3px 3px 3px #222)',
                        filter: 'drop-shadow(3px 3px 3px #222)'}} />
                    <p>Health</p>
                </div>
            </div>
            {/*<h4 className={"block-title"}>My friends</h4>*/}
            {/*<Grid container spacing={1} style={{width: '95%', maxWidth: 330, margin: 'auto'}}>*/}
            {/*    <Grid size={10}>*/}
            {/*        <div className={"invite-btn"}>Пригласить друга <FontAwesomeIcon icon={faUserPlus} /></div>*/}
            {/*    </Grid>*/}
            {/*    <Grid size={2}>*/}
            {/*        <div className={"invite-btn"}><FontAwesomeIcon icon={faCopy} style={{marginLeft: 0, fontSize: 20}} /></div>*/}
            {/*    </Grid>*/}
            {/*</Grid>*/}
            {/*<h4 className={"block-title"}>У вас пока нет приглашенных</h4>*/}
            {/*<h4 className={"block-title _blue"}>Отправьте пригласительную ссылку другу и<br/>получите 10 STT на баланс за каждого, кто<br/>сделает хотя бы одно задание</h4>*/}
            {/*<Grid container spacing={1} style={{width: '95%', maxWidth: 330, margin: '0 auto 15px'}}>*/}
            {/*    <Grid size={8}>*/}
            {/*        <div className={"child _blue"}>@user</div>*/}
            {/*    </Grid>*/}
            {/*    <Grid size={4}>*/}
            {/*        <div className={"child _blue"} style={{textAlign: 'center'}}>+10 STT</div>*/}
            {/*    </Grid>*/}
            {/*</Grid>*/}
            {/*<Grid container spacing={1} style={{width: '95%', maxWidth: 330, margin: '0 auto 15px'}}>*/}
            {/*    <Grid size={8}>*/}
            {/*        <div className={"child"}>@user</div>*/}
            {/*    </Grid>*/}
            {/*    <Grid size={4}>*/}
            {/*        <div className={"child"} style={{textAlign: 'center'}}><FontAwesomeIcon icon={faClock} /></div>*/}
            {/*    </Grid>*/}
            {/*</Grid>*/}
            {showArtDialog !== ''
                && <div className={"art-wrapper-profile"}>
                    {showArtDialog === 'skip'
                        && <React.Fragment>
                            <img src={arrow} alt={'buy skip'} />
                            <h4>Rewind</h4>
                            <p style={{minHeight: 70}}>{parse(Locales[language].rewind)}</p>
                            <h2><img className={'coin'} src={coin} alt={''} style={{height: 38, marginRight: 5}}/>  100</h2>
                            {!artifacts.includes('skip') ?
                                <React.Fragment>
                                    {(level >= 2 && parseFloat(balance) >= 100)
                                        ? <React.Fragment><button onClick={() => {buyArtifact('skip')}}>{parse(Locales[language].purchase)}</button><span className={'backLink'} onClick={() => {setShowArtDialog(''); setScreenLayout('profile')}}>{parse(Locales[language].back)}</span></React.Fragment>
                                        : <React.Fragment>
                                            {level >= 2
                                                ? <React.Fragment>
                                                    <button className={'close-btn'}>{parse(Locales[language].purchase)}</button>
                                                    <span style={{display: "block", margin: "15px auto", textAlign: "center", color: 'red', fontSize: 12}}>{language === 'RU' ? 'Недостаточно монет' : 'Insufficient coins'}</span>
                                                    <span className={'backLink'} onClick={() => {setShowArtDialog(''); setScreenLayout('profile')}}>{parse(Locales[language].back)}</span>
                                                  </React.Fragment>
                                                : <React.Fragment>
                                                    <p style={{fontSize: 16, width: '90%', margin: 'auto'}}>{parse(Locales[language].notAllowed)} {levels[2].name}</p>
                                                    <button className={'close-btn'} onClick={() => {setShowArtDialog(''); setScreenLayout('profile')}}>{parse(Locales[language].back)}</button>
                                                  </React.Fragment>
                                            }

                                          </React.Fragment>
                                    }
                                </React.Fragment>
                                : <button className={'close-btn'} onClick={() => {setShowArtDialog(''); setScreenLayout('profile')}}>{parse(Locales[language].back)}</button>
                            }
                        </React.Fragment>
                    }
                    {showArtDialog === 'shield'
                        && <React.Fragment>
                            <img src={protect} alt={'buy skip'} style={{width: 90, top: 90}} />
                            <h4>Shield</h4>
                            <p style={{minHeight: 70}}>{parse(Locales[language].shield)}</p>
                            <h2><img className={'coin'} src={coin} alt={''} style={{height: 38, marginRight: 5}}/>  500</h2>
                            {!artifacts.includes('shield') ?
                                <React.Fragment>
                                    {(level >= 3  && parseFloat(balance) >= 500)
                                        ? <React.Fragment><button onClick={() => {buyArtifact('shield')}}>{parse(Locales[language].purchase)}</button><span className={'backLink'} onClick={() => {setShowArtDialog(''); setScreenLayout('profile')}}>{parse(Locales[language].back)}</span></React.Fragment>
                                        : <React.Fragment>
                                            {level >= 3
                                                ? <React.Fragment>
                                                    <button className={'close-btn'}>{parse(Locales[language].purchase)}</button>
                                                    <span style={{display: "block", margin: "15px auto", textAlign: "center", color: 'red', fontSize: 12}}>{language === 'RU' ? 'Недостаточно монет' : 'Insufficient coins'}</span>
                                                    <span className={'backLink'} onClick={() => {setShowArtDialog(''); setScreenLayout('profile')}}>{parse(Locales[language].back)}</span>
                                                </React.Fragment>
                                                : <React.Fragment>
                                                    <p style={{fontSize: 16, width: '90%', margin: 'auto'}}>{parse(Locales[language].notAllowed)} {levels[3].name}</p>
                                                    <button className={'close-btn'} onClick={() => {setShowArtDialog(''); setScreenLayout('profile')}}>{parse(Locales[language].back)}</button>
                                                </React.Fragment>
                                            }

                                        </React.Fragment>
                                    }
                                </React.Fragment>
                                : <button className={'close-btn'} onClick={() => {setShowArtDialog(''); setScreenLayout('profile')}}>{parse(Locales[language].back)}</button>
                            }
                        </React.Fragment>
                    }
                    {showArtDialog === 'heal'
                        && <React.Fragment>
                            <img src={shield} alt={'buy skip'} style={{width: 90, top: 110}} />
                            <h4>Health</h4>
                            <p style={{minHeight: 70}}>{parse(Locales[language].health)}</p>
                            <h2><img className={'coin'} src={coin} alt={''} style={{height: 38, marginRight: 5}}/>  1000</h2>
                            {!artifacts.includes('heal') ?
                                <React.Fragment>
                                    {(level >= 5 && parseFloat(balance) >= 1000)
                                        ? <React.Fragment><button onClick={() => {buyArtifact('heal')}}>{parse(Locales[language].purchase)}</button><span className={'backLink'} onClick={() => {setShowArtDialog(''); setScreenLayout('profile')}}>{parse(Locales[language].back)}</span></React.Fragment>
                                        : <React.Fragment>
                                            {level >= 5
                                                ? <React.Fragment>
                                                    <button className={'close-btn'}>{parse(Locales[language].purchase)}</button>
                                                    <span style={{display: "block", margin: "15px auto", textAlign: "center", color: 'red', fontSize: 12}}>{language === 'RU' ? 'Недостаточно монет' : 'Insufficient coins'}</span>
                                                    <span className={'backLink'} onClick={() => {setShowArtDialog(''); setScreenLayout('profile')}}>{parse(Locales[language].back)}</span>
                                                </React.Fragment>
                                                : <React.Fragment>
                                                    <p style={{fontSize: 16, width: '90%', margin: 'auto'}}>{parse(Locales[language].notAllowed)} {levels[5].name}</p>
                                                    <button className={'close-btn'} onClick={() => {setShowArtDialog(''); setScreenLayout('profile')}}>{parse(Locales[language].back)}</button>
                                                </React.Fragment>
                                            }

                                        </React.Fragment>
                                    }
                                </React.Fragment>
                                : <button className={'close-btn'} onClick={() => {setShowArtDialog(''); setScreenLayout('profile')}}>{parse(Locales[language].back)}</button>
                            }
                        </React.Fragment>
                    }
                </div>
            }
        </div>
    )
}